module.exports = __webpack_public_path__ + "img/Eutrema_salsugineum.6aad7104.jpg";